<div class="my-container" [hidden]="!loading"><mat-progress-bar mode="indeterminate"></mat-progress-bar></div>
<div class='alert alert-danger malert-danger' *ngIf="err_validation">{{ err }}</div>
<div class='alert alert-danger malert-danger' *ngIf="err_internet_validation">{{ err_internet_text }} <span><i class="fas fa-sync icon" ></i></span></div>

<div mat-dialog-title class="matDialogTitle">
  <span> فرم درخواست تولید </span>
  <span class="close" (click)="close()" ><mat-icon>close</mat-icon></span>
</div>
